import { isUndefined, some } from "lodash";

import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { UpdateCustomerPayload } from "components/CustomerModal/components/CustomerNotes/hooks";
import type { Customer, CustomerNote } from "models";

export const updateCustomerNote = (customer: Customer, note: CustomerNote) => {
  if (!customer.notes) return;

  const noteIdx = customer.notes.findIndex(cn => cn.id === note.id);
  if (noteIdx < 0) return;

  return { ...customer, notes: customer.notes.with(noteIdx, { ...customer.notes[noteIdx], ...note }) };
};

export const useUpdateCustomerNoteMutation = () =>
  useTypedMutation<CustomerNote, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/customers/note/update", payload, ENV.dealerBaseURL);
    },
    onSuccess: note => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      const updatedCustomer: UpdateCustomerPayload = {
        ...(appointment.customer_owner?.id === note.customer_id && { customer_owner: updateCustomerNote(appointment.customer_owner, note) }),
        ...(appointment.customer_driver?.id === note.customer_id && { customer_driver: updateCustomerNote(appointment.customer_driver, note) }),
        ...(appointment.customer_contract?.id === note.customer_id && { customer_contract: updateCustomerNote(appointment.customer_contract, note) })
      };

      if (!Object.keys(updatedCustomer).length || some(updatedCustomer, isUndefined)) return;
      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, ...updatedCustomer });
    }
  });
